import API from "../BaseURL";

const configJson = {
  headers: {
    "content-type": "application/json",
  },
};


export async function getAllDomains() {
  const res = API.get(`/domains/`, configJson);
  return res;
}


export async function getDomainsByClient(user_id) {
  if (!user_id) {
    return;
  }
  const res = API.get(`domains/client/${user_id}`, configJson);
  return res;
}



export async function getDomainInfo(domain_id) {
  const res = API.get(`/domains/${domain_id}`, configJson);
  return res;
}

export async function createDomain(data) {
  const res = API.post(`/domains/`, data, configJson);
  return res;
}

export async function updateDomain(domain_id, data) {
  const res = API.put(`/domains/${domain_id}/`, data, configJson);
  return res;
}

export async function deleteDomain(domain_id) {
  const res = API.delete(`/domains/${domain_id}/`, configJson);
  return res;
}
